import React from "react";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import {
  canViewAllOrganizationClients,
  hasOwnAssignedClientsOnly,
} from "../../../utils/organization-permissions-helpers";
import { parseAthletesOrganizationInfoToClientListCoachRole } from "../../../utils/user-helpers";
import Chat from "./Chat";
import { EditGroupModalComponent } from "./modals/EditGroupModal";
import { MassMessageModalComponent } from "./modals/MassMessageModal";
import { NewGroupModalComponent } from "./modals/NewGroupModal";

const ChatController = async ({ res, req, locals, load }) => {
  const { query = {} } = req;
  const modal = query.modal || {};
  const {
    initId,
    groupParticipants,
    groupSubject,
    groupImage,
    groupChatId,
    allGroupChats,
    isAutoManaged,
    groupGuests,
  } = query;

  const isAllowToViewAllOrganizationsAthletes = canViewAllOrganizationClients(
    locals.organizationRoleName
  );

  if (
    locals.activeUser.organizationId &&
    isAllowToViewAllOrganizationsAthletes &&
    !locals.allAthletesFromOrganization
  ) {
    await load("allAthletesFromOrganization");
  }

  if (
    locals.activeUser.organizationId &&
    isAllowToViewAllOrganizationsAthletes &&
    !locals.usersOrganization
  ) {
    await load("usersOrganization");
  }

  const isRegularCoach =
    !locals.activeUser.organizationId &&
    locals.activeUser.permissions &&
    locals.activeUser.permissions?.includes("coach");

  const athletesToShow =
    isRegularCoach || hasOwnAssignedClientsOnly(locals.organizationRoleName)
      ? parseAthletesOrganizationInfoToClientListCoachRole(locals.activeUser)
      : locals.allAthletesFromOrganization;

  //load modal
  locals.modal = {
    "create-chat-group": (
      <NewGroupModalComponent
        athletesToShow={athletesToShow}
        usersOrganization={locals.usersOrganization}
        activeUser={locals.activeUser}
        referAsClients={Boolean(locals.activeUser.referAsClients)}
        allGroupChats={allGroupChats}
        hasAutoManagedChat={!!locals.activeUser.autoManagedChatId}
        isTeamCoach={locals.organizationRoleName === "Team Coach"}
      />
    ),
    "edit-chat-group": (
      <EditGroupModalComponent
        athletesToShow={athletesToShow}
        usersOrganization={locals.usersOrganization}
        activeUser={locals.activeUser}
        referAsClients={Boolean(locals.activeUser.referAsClients)}
        groupParticipants={groupParticipants}
        groupSubject={groupSubject}
        groupImage={groupImage}
        groupChatId={groupChatId}
        allGroupChats={allGroupChats}
        isAutoManaged={isAutoManaged === true || isAutoManaged === "true"}
        groupGuests={groupGuests || ""}
      />
    ),
    "mass-message": <MassMessageModalComponent />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  if (initId) res.body = <Chat initId={initId} />;
  else res.body = <Chat />;
};

export default ChatController;
